import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Polyline, useMap } from 'react-leaflet';
import { greenIcon, orangeIcon, carIcon, DEFAULT_MAP_CENTER } from './mapIcons';

function FitBounds({ from, to, driver }) {
  const map = useMap();
  useEffect(() => {
    if (from && to) {
      const points = [from, to];
      if (driver) points.push(driver);
      map.fitBounds(points, { padding: [50, 50] });
    } else if (from) {
      map.setView(from, 13);
    } else if (to) {
      map.setView(to, 13);
    }
  }, [from, to, driver, map]);
  return null;
}

export default function RideMap({ fromCoords, toCoords, fromLabel, toLabel, driverCoords }) {
  const defaultCenter = DEFAULT_MAP_CENTER;
  const [routePoints, setRoutePoints] = useState(null);

  useEffect(() => {
    if (!fromCoords || !toCoords) { setRoutePoints(null); return; }
    const [fromLat, fromLng] = fromCoords;
    const [toLat, toLng] = toCoords;
    fetch(`https://router.project-osrm.org/route/v1/driving/${fromLng},${fromLat};${toLng},${toLat}?overview=full&geometries=geojson`)
      .then((r) => r.json())
      .then((data) => {
        if (data.routes && data.routes[0]) {
          // OSRM returns [lng, lat], Leaflet needs [lat, lng]
          setRoutePoints(data.routes[0].geometry.coordinates.map(([lng, lat]) => [lat, lng]));
        } else {
          setRoutePoints([fromCoords, toCoords]);
        }
      })
      .catch(() => setRoutePoints([fromCoords, toCoords]));
  }, [fromCoords, toCoords]);

  return (
    <MapContainer
      center={fromCoords || toCoords || defaultCenter}
      zoom={12}
      className="w-full h-64 rounded-2xl z-0"
      scrollWheelZoom={false}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {fromCoords && (
        <Marker position={fromCoords} icon={greenIcon}>
          <Popup>{fromLabel || 'Pickup'}</Popup>
        </Marker>
      )}
      {toCoords && (
        <Marker position={toCoords} icon={orangeIcon}>
          <Popup>{toLabel || 'Drop-off'}</Popup>
        </Marker>
      )}
      {driverCoords && (
        <Marker position={driverCoords} icon={carIcon}>
          <Popup>Driver</Popup>
        </Marker>
      )}
      {routePoints && <Polyline positions={routePoints} color="#3b82f6" weight={4} opacity={0.7} />}
      <FitBounds from={fromCoords} to={toCoords} driver={driverCoords} />
    </MapContainer>
  );
}
